import { useEffect, useState } from "react";
import { getDownloadURL, ref } from "firebase/storage";
import { storage } from "../../utilities/firebase";

const AddDocuments = (props) => {
    const [allAdditionalDocuments, setAllAdditional] = useState([]);

    useEffect(() => {
        setAllAdditional(props.additionalDocuments);
    }, [props.additionalDocuments]);

    const downloadFile = async (filename, type) => {
        try {
            const downloadRef = ref(storage, `files/${filename}`);
            const url = await getDownloadURL(downloadRef);
            return url;
        } catch (err) {
            console.error(err);
            return null;
        }
    };

    return (
        <div className="card p-4 w-75">
            <h5 className="display-5 mb-3">Additional Documents</h5>

            <p className="card-text">Company related:</p>
            {allAdditionalDocuments.length > 0 &&
                allAdditionalDocuments.map((doc, index) => {
                    if (doc.blacklist_id === props.item.blacklist_id && doc.type === 'Company related') {
                        return (
                            <DocumentLink 
                                key={index} 
                                doc={doc} 
                                downloadFile={downloadFile} 
                                type="company related" 
                            />
                        );
                    }
                    return null;
                })
            }

            <p className="card-text">Representative related:</p>
            {allAdditionalDocuments.length > 0 &&
                allAdditionalDocuments.map((doc, index) => {
                    if (doc.blacklist_id === props.item.blacklist_id && doc.type === 'Representative related') {
                        return (
                            <DocumentLink 
                                key={index} 
                                doc={doc} 
                                downloadFile={downloadFile} 
                                type="representative related" 
                            />
                        );
                    }
                    return null;
                })
            }

            <p className="card-text">Incident related:</p>
            {allAdditionalDocuments.length > 0 &&
                allAdditionalDocuments.map((doc, index) => {
                    if (doc.blacklist_id === props.item.blacklist_id && doc.type === 'Incident related') {
                        return (
                            <DocumentLink 
                                key={index} 
                                doc={doc} 
                                downloadFile={downloadFile} 
                                type="incident related" 
                            />
                        );
                    }
                    return null;
                })
            }
        </div>
    );
};

const DocumentLink = ({ doc, downloadFile, type }) => {
    const [url, setUrl] = useState(null);

    useEffect(() => {
        const fetchUrl = async () => {
            const fileUrl = await downloadFile(doc.name, type);
            setUrl(fileUrl);
        };
        fetchUrl();
    }, [doc.name, downloadFile, type]);

    if (!url) {
        return <span>Loading...</span>;
    }

    return (
        <a id={doc.name} className="text-secondary" href={url} target="_blank" rel="noopener noreferrer">
            {doc.name}
        </a>
    );
};

export default AddDocuments;
